module.exports = __webpack_public_path__ + "static/media/bt-compartilhar-hover.48f00051.svg";